import newsify_image  from '../assets/newsify_profolio_image.png';
import mapexpo_image from '../assets/mapexpo_website.png';
import bhagwathgita_image from '../assets/bhagwathgita.png';

export const projectsData = [
  {
    name: "Newsify App",
    heading: "Newsify : Andriod app for short News and live TV",
    details: "Newsify: Mobile app that delivers real-time news updates from multiple trusted sources. Developed with Flutter for the front-end and Python for the back-end, the app provides a seamless user experience with customizable news feeds and the ability to stream live TV News Channels . Integrated with multiple news APIs and designed with a clean and intuitive user interface with support for 8 different languages including English, Telugu, Hindi, Bengali, Kannada, Malayalam, Tamil, and Gujarati",
    thumb: newsify_image,
    links: {
      playstore: "https://play.google.com/store/apps/details?id=com.garudadev.news",
    }
  },
  {
    name: "MapExpo Website",
    heading: "MapExpo : Website of interactive maps",
    details: "MapExpo : A collection of interactive choropleth maps based on various political, cultural, linguistic, religious, and other themes. Designed and developed by me using JavaScript, HTML, and CSS for the front-end, and Python for the back-end data processing. In addition, the website includes an admin panel developed using Flutter. These maps provide users with an engaging and informative experience. Each map highlights different themes, ranging from political boundaries to linguistic diversity, and is designed to provide users with insights into various aspects of the India. With MapExpo, users can easily explore and interact with these fascinating maps, gaining a deeper understanding of our India.",
    thumb: mapexpo_image,
    links: {
      live: "https://garudadevdataservices.github.io/mapexpo/",
    }
  },
  {
    name: "Bhagawathgita Telugu App",
    heading: "An complete collection of Bhagavad Gita in Telugu literature.",
    details: "Bhagwathgita - Telugu: An interactive mobile app and website designed and developed by me using Flutter. The app provides a seamless learning experience for Bhagwat Geeta, featuring text, audio, and video content in Telugu language. With an intuitive UI design, the app makes it easy for users to navigate through the content and learn at their own pace. The website is a companion to the mobile app, and allows users to access the same content on their desktop or laptop computers. Bhagwathgita - Telugu is a powerful application for anyone seeking to learn the teachings of Bhagwat Geeta in a convenient and accessible format.",
    thumb:bhagwathgita_image,
    links: {
      playstore: "https://play.google.com/store/apps/details?id=com.bhagawathgita.telugu",
      live: "https://garudadevdataservices.github.io/bhagwathgita/"
    }
  },
  {
    name: "TV Schedule API",
    heading: "A Tv Schedule api that can easy integrate with any application",
    details: "REST API build using flask having various end point services which provides schedule for all TV channels which includes almost 14 Indian channels",
    thumb: "https://res.cloudinary.com/deqlgt3yd/image/upload/v1621411520/samples/tvsch_bs3jk9.png",
    links: {
      live: "https://rapidapi.com/Garuda07/api/indian-tv-schedule",
      repo: "https://github.com/datta07/Tv-Channel-Schedule-API"
    }
  },
  {
    name: "SONGS DOWNLOAD BOT",
    heading: "Get all you favorite songs by simply chating with this bot",
    details: "Telegram based song downloading bot developed using python, serving more than 200+ daily users and almost servers over a half lakh songs till now. Lyrics along the song is one of the major asset for this bot",
    links: {
      live: "https://t.me/garudaDevBot",
    }
  },
  {
    name: "Indian Shapefiles",
    heading: "a complete shapefile kit for GIS",
    details: "One of major step on contribution for open-source, I created various Shape-files and Geojson files for various categories of India taken from OPENSTREETMAP website using some heavy automated programs.Categories provided are INDIAN STATES,UTS,DISTRICTS AND SUB-DISTRICTS,METROPOLITION",
    links: {
      repo: "https://github.com/datta07/INDIAN-SHAPEFILES"
    }
  }
];

export const writingsData = [
  {
    title: "Machine Learning - Stanford University",
    publishedOn: "Coursera",
    link: "https://www.coursera.org/account/accomplishments/verify/9WZKXCYXHBEZ"
  },
  {
    title: "Problem Solving through Programming in C",
    publishedOn: "NPTEL",
    link: "https://dattaakula.github.io/image_bin/Problem%20Solving%20through%20Programming%20in%20C.jpg"
  },
  {
    title: "Programming, Data Structures and Algorithms using Python",
    publishedOn: "NPTEL",
    link: "https://dattaakula.github.io/image_bin/Programming,%20Data%20Structures%20and%20Algorithms%20using%20Python.jpg"
  }
];




// WEBPACK FOOTER //
// ./src/data/data.js